// libs
import { connect } from 'react-redux';
import get from 'lodash/get';

// redux selectors
import { getTotalCount, getProducts } from 'shared/store/wishlist/selectors';
import { getRemoteConfig } from 'shared/store/remoteConfigs/selectors';

// component
import Analytics from './Analytics';

const mapStateToProps = (state: any, ownProps: any) => {
  const { isMobile = false } = ownProps;
  const salePromotionConfig = get(getRemoteConfig(state, 'priceReveal'), 'salePromotionConfig');

  return {
    totalCount: getTotalCount(state),
    products: getProducts(state),
    isPriceRevealEnabled: get(
      getRemoteConfig(state, 'priceReveal'),
      isMobile ? 'mobile' : 'desktop',
      false
    ),
    isSalePriceLiveEnabled: isMobile ? salePromotionConfig.mobile : salePromotionConfig.desktop,
  };
};

export default connect(mapStateToProps)(Analytics);
